const ROOTS = {
  APP: '/app',
}

export const paths = {
  page403: '/403',
  page404: '/404',
  page500: '/500',
  login: `/login`,
  app: {
    dashboard: `${ROOTS.APP}/dashboard`,
    profile: `${ROOTS.APP}/users/profile`,
  },
}
